import { useMutation, useQuery } from "@tanstack/react-query"
import { useRestAPI } from "./axiosAPI"
import axios from "axios";
import { removePATtoken, storePATtoken } from "src/lib/utils";
import { setadminDetails } from "src/redux/admin.slice/admin.slice";
import { useDispatch } from "react-redux";


export type AdminData = {
    displayName: string;
    publicAlias: string;
    emailAddress: string;
    coreRevision: number;
    timeStamp: string;
    id?: string;
    revision: number;
}


export function useAuthenticationHook() {

    const api = useRestAPI()

    const { mutateAsync: loginByPAT,
        isPending: isLoginning,
        isError: isLoginError,
        error: loginError,


    } = useMutation({
        mutationFn: async ({
            PAT
        }: {
            PAT: string
        }) => {

            try {
                const response = await axios.get<AdminData>(`https://app.vssps.visualstudio.com/_apis/profile/profiles/me?api-version=${process.env.REACT_APP_API_VERSION}`, {
                    auth: {
                        username: "",
                        password: PAT
                    }
                })

                if (response.data.id) {

                    storePATtoken(PAT)


                    return {
                        success: true,
                        data: response.data
                    }
                }

                removePATtoken()

                return {
                    success: false,
                    msg: 'something went wrong'
                }

            } catch (error) {
                if (axios.isAxiosError(error)) {
                    if (error.response?.status) {
                        removePATtoken()
                        return {
                            success: false,
                            msg: 'Invalid PAT'
                        }
                    }
                }
                removePATtoken()
                return {
                    success: false,
                    msg: 'Internal error'
                }
            }
        },

    })
    const { mutateAsync: adminTest,
        isPending: isAdminTesting,
        isError: isAdminTestingError,
        error: adminTestingError,


    } = useMutation({
        mutationFn: async () => {
            const response = await api.post<{ data: AdminData }, {}>({
                url: `${process.env.REACT_APP_BACKEND_URL}/v1/admin/admin-test`,
                withCredentials: true
            })




            if (response.success === false) {
                return response
            }
            return response
        },

    })

    const {
        mutateAsync: logoutAdmin,
        isPending: isLogoutAdminPending,
    } = useMutation({
        mutationFn: async () => {
            // const response = await api.post({
            //     url: `${process.env.REACT_APP_BACKEND_URL}/v1/admin/logout`,
            //     withCredentials: true
            // })
            // if (response.success === false) {
            //     return response
            // }
            localStorage.removeItem('PATtoken')
            window.location.href = '/'
            // return response
        },
    })



    return {
        loginByPAT,
        isLoginning,
        isLoginError,
        loginError,
        adminTest,
        isAdminTesting,
        isAdminTestingError,
        adminTestingError,
        logoutAdmin,
        isLogoutAdminPending
    }





}


export function useGetAdminByToken({
    trigger = true
}: {
    trigger?: boolean
}) {
    const api = useRestAPI()
    const dispatch = useDispatch()

    const {
        data: adminData,
        error: adminError,
        isError: isgetAdminbyTokenError,
        isFetched: isgetAdminbyTokenFetched,
        isFetching: isgetAdminbyTokenFetching,
        isLoading: isgetAdminbyTokenLoading,
        refetch: getAdminbyTokenRefetch
    } = useQuery({
        queryKey: ['get-admin-by-token'],
        queryFn: async () => {
            const response = await api.get< AdminData >({
                url: `https://app.vssps.visualstudio.com/_apis/profile/profiles/me?api-version=${process.env.REACT_APP_API_VERSION}`,
                mode: 'protected',
            })

            console.log(response)

            if(response.success===true){
                dispatch(setadminDetails(response))

            }

            if (response.success === false) {
                throw response
            }

            return response
        },
        enabled: trigger,
        retry: false,
        refetchOnWindowFocus: false
    })

    return {
        adminData,
        adminError,
        isgetAdminbyTokenError,
        isgetAdminbyTokenFetched,
        isgetAdminbyTokenFetching,
        isgetAdminbyTokenLoading,
        getAdminbyTokenRefetch
    }

}